import DataSelectService from 'services/DataSelectService';

class DataSelectAdapter extends DataSelectService {

  orderTypesMap = {
    0: { value: 0, label: 'UNKNOWN' },
    1: { value: 1, label: 'ORDER_VOICE' },
    2: { value: 2, label: 'ORDER_CLOB' },
    3: { value: 3, label: 'ORDER_RFQ' },
    4: { value: 4, label: 'ORDER_AUCTION' },
    5: { value: 5, label: 'AUCTION_LIFECYCLE' },
    6: { value: 6, label: 'AUCTION_AGGREGATE' },
    7: { value: 7, label: 'TRADE_LIMITED' },
    8: { value: 8, label: 'TRADE_FULL' },
    9: { value: 9, label: 'TRADE_AGGREGATE' },
    10: { value: 10, label: 'ORDER_CLOB_DELTA' },
    11: { value: 11, label: 'ORDER_CLOB_SINGLE' }
  };

  mapOrderTypes(list) {
    return list.map((value) => {
      // Use the mapping if available, otherwise fallback to UNKNOWN
      return this.orderTypesMap[value] || this.orderTypesMap[0];
    });
  }

  mapList(list, valueProp = null, labelProp = null) {
    return list.map((item) => {
      return {
        value: valueProp ? item[valueProp] : item,
        label: labelProp ? item[labelProp] : item
      };
    });
  }

  loadTVs(params) {
    return this.getTVs(params.datatype).then((results) => this.mapList(results, 'MIC', 'Name'));
  }

  loadAssetClasses(params) {
    return this.getAssetClasses(params.datatype, params.tv).then(({ assetClasses, subassetClasses, instruments, miclist, ordertypelist }) => {
      const assets = this.mapList(assetClasses);

      if (subassetClasses) {
        const subassets = this.mapList(subassetClasses);
        if (instruments) {
          const instrumentList = this.mapList(instruments);
          if (miclist) {
            const mic = this.mapList(miclist);
            if (ordertypelist) {
              const ordertype = this.mapOrderTypes(ordertypelist);
              return { assets, subassets, instrumentList, mic, ordertype }
            } else {
              return { assets, subassets, instrumentList, mic }
            }
          } else {
            return { assets, subassets, instrumentList }
          }
        } else {
          return { assets, subassets }
        }
      } else {
        return { assets }
      }
    });
  }

  loadSubAssetClasses(params) {
    return this.getSubAssetClasses(params.datatype, params.tv, params.assetclass).then(({ subassetClasses, instruments, miclist, ordertypelist }) => {
      const subassets = this.mapList(subassetClasses);
      if (instruments) {
          const instrumentList = this.mapList(instruments);
          if (miclist) {
            const mic = this.mapList(miclist);
            if (ordertypelist) {
              const ordertype = this.mapOrderTypes(ordertypelist);
              return { subassets, instrumentList, mic, ordertype }
            } else {
              return { subassets, instrumentList, mic }
            }
          } else {
            return { subassets, instrumentList }
          }
      } else {
        return { subassets }
      }
    });
  }

  loadInstruments(params) {
    return this.getInstruments(params.datatype, params.tv, params.assetclass, params.subassetclass)
        .then(({ instruments, miclist, ordertypelist }) => {
      const instrumentList = this.mapList(instruments);
      if (miclist) {
        const mic = this.mapList(miclist);
        if (ordertypelist) {
          const ordertype = this.mapOrderTypes(ordertypelist);
          return { instrumentList, mic, ordertype }
        } else {
          return { instrumentList, mic }
        }
      }
      else {
        return { instrumentList }
      }
    });
  }

  loadSegmentMics(params) {
    return this.getSegmentMics(
      params.datatype,
      params.tv,
      params.assetclass,
      params.subassetclass,
      params.instrument
    ).then((results) => this.mapList(results));
  }

  loadOrderTypes(params) {
    return this.getOrderTypes(
      params.datatype,
      params.tv,
      params.assetclass,
      params.subassetclass,
      params.instrument,
      params.instrumentmic,
    ).then((results) => this.mapOrderTypes(results));
  }
}

const dataSelectAdapter = new DataSelectAdapter();
export default dataSelectAdapter;



// WEBPACK FOOTER //
// ./src/adapters/DataSelectsAdapter.js